import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { MarcoTelefono } from '../componentes/MarcoTelefono.js';
import { usePendientes } from '../componentes/useRed.js';
import { MisVisitas } from './MisVisitas.js';
import { Control } from './Control.js';
import { Consentimiento } from './Consentimiento.js';
import { FirmaProfesional } from './FirmaProfesional.js';
import { Pendientes } from './Pendientes.js';
import { Acta } from './Acta.js';
import { Perfil } from './Perfil.js';

const TABS: { ruta: string; etiqueta: string; icono: string }[] = [
  { ruta: '/medico', etiqueta: 'Visitas', icono: '📋' },
  { ruta: '/medico/pendientes', etiqueta: 'Pendientes', icono: '☁️' },
  { ruta: '/medico/perfil', etiqueta: 'Perfil', icono: '👤' },
];

export function MedicoApp() {
  const loc = useLocation();
  const navegar = useNavigate();
  const pendientes = usePendientes();
  const mostrarTabs = TABS.some((t) => t.ruta === loc.pathname);

  return (
    <MarcoTelefono>
      <Routes>
        <Route index element={<MisVisitas />} />
        <Route path="control" element={<Control />} />
        <Route path="consentimiento" element={<Consentimiento />} />
        <Route path="firma" element={<FirmaProfesional />} />
        <Route path="pendientes" element={<Pendientes />} />
        <Route path="acta" element={<Acta />} />
        <Route path="perfil" element={<Perfil />} />
      </Routes>

      {mostrarTabs && (
        <div className="tabbar">
          {TABS.map((t) => {
            const activo = loc.pathname === t.ruta;
            return (
              <button key={t.ruta} className={`tab ${activo ? 'activo' : ''}`} onClick={() => navegar(t.ruta)}>
                <div style={{ fontSize: 20 }}>{t.icono}</div>
                {t.ruta === '/medico/pendientes' && pendientes > 0 && <span className="punto">{pendientes}</span>}
                <div>{t.etiqueta}</div>
              </button>
            );
          })}
        </div>
      )}
    </MarcoTelefono>
  );
}
